import { Dispatch } from "redux";
import ArchiveDocumentInteractor from "../../../domain/interactors/ArchiveDocumentInteractor";
import { RootState } from "../reducers";

export enum ArchiveActionTypes {
  ARCHIVE_SEARCH_PROCESSING = "@archive/SEARCH_PROCESSING",
  ARCHIVE_SEARCH_COMPLETE = "@archive/SEARCH_COMPLETE",
  ARCHIVE_SEARCH_ERROR = "@archive/SEARCH_ERROR",
  ARCHIVE_FILES_PROCESSING = "@archive/FILES_PROCESSING",
  ARCHIVE_FILES_COMPLETE = "@archive/FILES_COMPLETE",
  ARCHIVE_FILES_ERROR = "@archive/FILES_ERROR",
  ARCHIVE_DOWNLOAD_PROCESSING = "@archive/DOWNLOAD_PROCESSING",
  ARCHIVE_DOWNLOAD_COMPLETE = "@archive/DOWNLOAD_COMPLETE",
  ARCHIVE_DOWNLOAD_ERROR = "@archive/DOWNLOAD_ERROR",
  ARCHIVE_ORDER_DATA_PROCESSING = "@archive/ORDER_DATA_PROCESSING",
  ARCHIVE_ORDER_DATA_COMPLETE = "@archive/ORDER_DATA_COMPLETE",
  ARCHIVE_ORDER_DATA_ERROR = "@archive/ORDER_DATA_ERROR",
  ARCHIVE_CLEAR = "@archive/CLEAR",
}

export const searchArchive = (
  orgId: string,
  lastName: string,
  firstName: string,
  studentId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { archiveDocumentInteractor: ArchiveDocumentInteractor }
  ) => {
    dispatch({ type: ArchiveActionTypes.ARCHIVE_SEARCH_PROCESSING });
    try {
      const results = await deps.archiveDocumentInteractor.searchArchive(
        orgId,
        lastName,
        firstName,
        studentId
      );
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_SEARCH_COMPLETE,
        payload: results,
      });
    } catch (error) {
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_SEARCH_ERROR,
        payload: error,
      });
    }
  };
};

export const listArchiveFiles = (orgId: string, folderId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { archiveDocumentInteractor: ArchiveDocumentInteractor }
  ) => {
    dispatch({ type: ArchiveActionTypes.ARCHIVE_FILES_PROCESSING });
    try {
      const files = await deps.archiveDocumentInteractor.listArchiveFiles(
        orgId,
        folderId
      );
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_FILES_COMPLETE,
        payload: { folderId, files },
      });
    } catch (error) {
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_FILES_ERROR,
        payload: error,
      });
    }
  };
};

export const getArchiveFile = (
  orgId: string,
  folderId: string,
  fileName: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { archiveDocumentInteractor: ArchiveDocumentInteractor }
  ) => {
    dispatch({ type: ArchiveActionTypes.ARCHIVE_DOWNLOAD_PROCESSING });
    try {
      const blob = await deps.archiveDocumentInteractor.getArchiveFile(
        orgId,
        folderId,
        fileName
      );
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_DOWNLOAD_COMPLETE,
      });
      return blob;
    } catch (error) {
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_DOWNLOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const clearArchive = () => ({
  type: ArchiveActionTypes.ARCHIVE_CLEAR,
});

export const getOrderData = (orgId: string, folderId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { archiveDocumentInteractor: ArchiveDocumentInteractor }
  ) => {
    dispatch({ type: ArchiveActionTypes.ARCHIVE_ORDER_DATA_PROCESSING, payload: folderId });
    try {
      const data = await deps.archiveDocumentInteractor.getOrderData(
        orgId,
        folderId
      );
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_ORDER_DATA_COMPLETE,
        payload: { folderId, data },
      });
    } catch (error) {
      dispatch({
        type: ArchiveActionTypes.ARCHIVE_ORDER_DATA_ERROR,
        payload: error,
      });
    }
  };
};
